import useModals from "./useModals"
import DialogModal from "web/components/DialogModal/DialogModal"

import { humanize, titleize } from "web/services/inflector"

function removeDealAssetKind(kind) {
  return kind === "deal_asset" ? "Asset from this Deal" : kind
}

export default function useDialogModal(dialog) {
  const { showModal } = useModals()

  if (dialog !== undefined) {
    return async function () {
      return await showModal({
        fullScreen: false,
        heightPixels: dialog.heightPixels || 250,
        widthPixels: dialog.widthPixels || 600,
        title: dialog.title,
        isInputRequired: dialog.isInputRequired,
        component: ({ respond }) => (
          <DialogModal {...dialog} respond={respond} />
        ),
      })
    }
  }

  return async function ({
    title,
    heightPixels = 250,
    widthPixels = 600,
    ...dialogModalProps
  }) {
    return await showModal({
      fullScreen: false,
      heightPixels,
      widthPixels,
      title,
      component: ({ respond }) => (
        <DialogModal {...dialogModalProps} respond={respond} />
      ),
    })
  }
}

export const DialogCommands = {
  OK: { label: "OK", response: true },
  Continue: { label: "Continue", response: true },
  ConfirmDelete: { label: "Delete", variant: "primary_danger", response: true },
  Cancel: { label: "Cancel", variant: "secondary_default", response: false },
}

export const Dialogs = {
  New: (kind, isInputRequired = true) => ({
    title: `Add ${humanize(kind)}`,
    prompt: `What would you like to call this ${humanize(kind).toLowerCase()}?`,
    commands: [DialogCommands.OK, DialogCommands.Cancel],
    input: true,
    isInputRequired: isInputRequired,
  }),
  ConfirmBulkDelete: (kind) => ({
    title: `Delete ${titleize(removeDealAssetKind(kind))}`,
    prompt: `Are you sure you want to delete these ${humanize(
      removeDealAssetKind(kind)
    ).toLowerCase()}?`,
    commands: [DialogCommands.ConfirmDelete, DialogCommands.Cancel],
  }),
  ConfirmDelete: (kind) => ({
    title: `Delete ${humanize(removeDealAssetKind(kind))}`,
    prompt: `Are you sure you want to delete this ${humanize(
      removeDealAssetKind(kind)
    ).toLowerCase()}?`,
    commands: [DialogCommands.ConfirmDelete, DialogCommands.Cancel],
  }),
  ConfirmUpdate: ({
    kind,
    prompt = `Are you sure you want to update this ${humanize(
      kind
    ).toLowerCase()}?`,
  }) => ({
    title: `Update ${humanize(kind)}`,
    prompt,
    commands: [DialogCommands.Continue, DialogCommands.Cancel],
  }),
  Rename: (kind, placeholder, isInputRequired = true) => ({
    title: `Rename ${humanize(kind)}`,
    prompt: `What would you like to call this ${humanize(kind).toLowerCase()}?`,
    commands: [{ label: "Rename", response: true }, DialogCommands.Cancel],
    input: true,
    inputPlaceholder: placeholder,
    isInputRequired: isInputRequired,
  }),
  Duplicate: (kind, placeholder, isInputRequired = true) => ({
    title: `Copy ${humanize(kind)}`,
    prompt: `What would you like to call this new ${humanize(
      kind
    ).toLowerCase()}?`,
    commands: [{ label: "Duplicate", response: true }, DialogCommands.Cancel],
    input: true,
    inputPlaceholder: placeholder + " Copy",
    isInputRequired: isInputRequired,
  }),
}
